import {FORTY_N_DEBUG} from '../models/debug.model';
import {isLocalhost} from './environment.service';

const isTruthy = (value: unknown): boolean =>
	value === true || value === 1 || value === 'true' || value === '1';

export class DebugService {
	private isDebug: boolean;

	constructor(
		search: string = window.location.search,
	) {
		this.isDebug = isLocalhost() || this.hasDebugParam(search);
	}

	isDebugMode(): boolean {
		return this.isDebug;
	}

	enableFromTrack(params?: Record<string, any>, trackData?: Record<string, any>): void {
		this.isDebug = this.isDebug
			|| isTruthy(params?.is_debug_mode)
			|| isTruthy(params?.[FORTY_N_DEBUG])
			|| isTruthy(params?.debug)
			|| isTruthy(trackData?.is_debug_mode);
	}

	hasDebugParam(search: string): boolean {
		return new URLSearchParams(search).get(FORTY_N_DEBUG) === '1';
	}
}

export const debugService = new DebugService();
